import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

/**
 * What a screen or a list shows when there is nothing to show yet: an icon on a soft wash of the
 * brand gradient, one line saying what is missing, one saying why, and the step that changes it.
 */
export function BrandPresenceEmptyState({
  icon,
  title,
  description,
  actions,
}: {
  icon: IconDefinition;
  title: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center motion-safe:animate-bp-fade-up">
      <span
        aria-hidden="true"
        className="relative mb-5 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-gradient-soft"
      >
        <span className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-primary/15" />
        <FontAwesomeIcon icon={icon} className="text-xl text-primary" />
      </span>
      <p className="m-0 text-base font-semibold text-slate-900">{title}</p>
      {description ? <p className="mt-1.5 mb-0 max-w-md text-sm leading-relaxed text-slate-500">{description}</p> : null}
      {actions ? <div className="mt-5 flex flex-wrap items-center justify-center gap-2">{actions}</div> : null}
    </div>
  );
}
